import logo from '@/assets/images/logo/logo-victoriacentral.png'
import fondoLogin from '@/assets/images/pages/login-victoriacentral.svg'

const host = process.env.VUE_APP_HOST
const hostApi = process.env.VUE_APP_HOST_API
const hostProcesarImagenes = process.env.VUE_APP_HOST_PROCESAR_IMAGENES

const folder = process.env.VUE_APP_FOLDER
const folderDocs = process.env.VUE_APP_FOLDER_DOCS

const version = '6.1.2'

const storagePrefix = process.env.VUE_APP_STORAGE_PREFIX
const idCliente = process.env.VUE_APP_ID_CLIENTE

const appNameShow = process.env.VUE_APP_MENU_TITLE.toUpperCase() || 'PLAYGOL'

export default {
  appName: appNameShow,

  logo,

  fondoLogin,

  api: {
    URL: `${hostApi}index.php/${folder}/`,

    URL_ADMINISTRACION: `${hostApi}index.php/adminplaygol/`,

    URL_PROCESO_IMAGENES: hostProcesarImagenes,

    URL_CARNET: hostApi,

    URL_PDF: `${host}/${folderDocs}/`,

    URL_DOCS_PETICIONES: `${host}/docs_peticiones/`,

    VERSION: version,

    STORAGE_PREFIX: storagePrefix,

    ID_CLIENTE: idCliente,

    URL_PROXY: `${hostApi}index.php/Proxy/image?url=`,
  },
}
